module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAAAAAA7suyFAAABGklEQVR4AcWS13JEIQxD8/+/GR9v773hjCcOZeA+R7u3nxFC8KW90FYNQ76g5Df8IwMIMGRCsD6cjxvQCQaVvf3qIGMG5G5myX/2BEY+crVkLgfv34MOkbU7JD/8vBV6H3lkGzd6iWaGkKoVOT1TQsVnaamB1vR5Vq2PbQZ5ZrVPSrYY9fNpfRgwcmnmdZVBP2C1FLq5o6y8xFiOjSj93FVZvoP5rBjvZ2RxD+axECqGkMI9Vt3BO/Q9s/RWSj22bDJH4LZDsxWKApEHnWciYzZXqg6Rl78t+8cRe0nD7DxpY+LHDs0MYs4Un3gyITPiNp3cSHI/8rDhWPYQoh+Il2Wsv64gxorF7H2SrQhG9mYTzF4ij5wnmbMAP1+sebcPgbKzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_placeholder.png
// module id = 317
// module chunks = 0